/** Разделы конструктора реестров */
export enum ESectionName {
    main = 'main',
    structure = 'structure',
    map = 'map',
    views = 'views',
    forms = 'forms',
    access = 'access',
    relation = 'relation',
    schedule = 'schedule',
    api_settings = 'api_settings',
    legacy = 'legacy',
    filter = 'filter',
}

/**
 * Типы сохранённых представлений реестра (бэк / конструктор).
 * TODO: добавить table — тогда виртуальный table в registry-views и разъезд с ERegistryViewKind можно схлопнуть
 */
export enum EViewTypes {
    kanban = 'kanban',
    timeline = 'timeline',
}

/** Способы отображения данных по связям */
export enum EViewRelation {
    /** Таблица с полями связи */
    TableRelation,
    /** Автодополнение */
    Autocomplete,
    /** Таблица с полями связанного реестра */
    TableRegistry,
    /** Диаграмма Ганта */
    FactorViewDataSource,
}

export enum EStructureFormComponentEvents {
    addFolder = 'addFolder',
    addItem = 'addItem',
    close = 'closePage',
    delete = 'delete',
    save = 'save',
    saveAndClose = 'saveAndClose',
}

export enum ERegistryFormComponentEvents {
    SaveRegistry = 'saveRegistry',
    SaveRegistryAndClose = 'saveRegistryAndClose',
}

export enum EStructureFormFields {
    addressVisibility = 'address_visibility',
    allowAddRubricator = 'allow_add_rubricator',
    altSelectMethod = 'alternative',
    applicationId = 'application_id',
    availableRubricator = 'available_rubricator',
    blockType = 'block_type',
    boolDefaultValue = 'bool_default_value',
    calcRules = 'calc_right',
    codeAvailableRubricator = 'code_available_rubricator',
    dataType = 'data_type',
    dateDefaultValueFrom = 'dateDefaultValueFrom',
    dateDefaultValueSingle = 'dateDefaultValueSingle',
    dateDefaultValueTo = 'dateDefaultValueTo',
    dateFormatId = 'date_format_id',
    dateType = 'type',
    digitDefaultValue = 'digitDefaultValue',
    drTableJson = 'dr_table_json',
    factorUnitId = 'factor_unit_id',
    factorUnitRatioId = 'factor_unit_ratio_id',
    factorViewId = 'factor_view_id',
    fieldMaxlength = 'field_maxlength',
    fileExt = 'file_ext',
    heightMax = 'height_max',
    interaction_url = 'interaction_url',
    interaction_request_url = 'interaction_request_url',
    interaction_user_id = 'interaction_user_id',
    interaction_status = 'interaction_status',
    interaction_status_send = 'interaction_status_send',
    interaction_status_field = 'interaction_status_field',
    interaction_kud_number = 'interaction_kud_number',
    interaction_dept = 'interaction_dept',
    interaction_date_create = 'interaction_date_create',
    interaction_date_answer = 'interaction_date_answer',
    interaction_date_planed_answer = 'interaction_date_planed_answer',
    interaction_status_error_info = 'interaction_status_error_info',
    intervalMax = 'interval_max',
    intervalMin = 'interval_min',
    isCrop = 'is_crop',
    isCurrentDate = 'is_current',
    isDeleteView = 'is_delete_view',
    isHiddenView = 'is_hidden_view',
    isLinkInfoSite = 'is_link_info_site',
    isPreview = 'is_preview',
    isReadonly = 'is_readonly',
    isReportAvg = 'is_report_avg',
    isShowFileInfo = 'is_show_file_info',
    isShowInTabs = 'is_show_in_tabs',
    isSubscribe = 'is_subscribe',
    keyword = 'keyword',
    linkDefaultUrl = 'link_url',
    linkedFieldId = 'linked_field_id',
    linkedFieldName = 'linked_field_name',
    listDefaultValue = 'list_string_default_value',
    listViewAsTree = 'list_view_as_tree',
    listViewTreeAsFolder = 'list_view_tree_as_folder',
    note = 'note',
    numberType = 'number_type',
    numerator = 'numerator',
    reestrId = 'reestr_id',
    reestrJson = 'reestr_json',
    registryId = 'registry_id',
    relationId = 'relation_id',
    requestCompletionStatus = 'request_completion_status',
    requestPlannedDateId = 'request_planned_data_id',
    requestRegistryId = 'request_registry_id',
    requiredCondition = 'required_condition',
    resultAutomaticCompletionRequest = 'result_automatic_completion_request',
    rubricator = 'rubricator',
    selectMethod = 'select_method',
    selectTreeLevelOpen = 'select_tree_level_open',
    showType = 'show_type',
    storeJson = 'store_json',
    storeType = 'store_type',
    stringDefaultValue = 'string_default_value',
    stringMask = 'string_mask',
    stringType = 'string_type',
    stringValidation = 'string_validation',
    technicalProcessDateId = 'technical_process_date_id',
    technicalProcessResultId = 'technical_process_result_id',
    technicalProcessStatusId = 'technical_process_status_id',
    textDefaultValue = 'text_default_value',
    textUseEditor = 'use_editor',
    useListFullName = 'use_list_full_name',
    userAccessId = 'user_access_id',
    viewCondition = 'view_condition',
    viewOfDisplayingLinks = 'view_of_displaying_links',
    widthMax = 'width_max',
    workSourceApplicationId = 'work_source_application_id',
}

export enum EDateTypes {
    date = 1,
    monthYear,
    year,
    month,
    dateTime,
    dayMonth,
}

export enum EStructureConditionFieldsDialog {
    main_value = 'main_value',
    second_value = 'second_value',
}

export enum EOperationType {
    filled = 'filled',
    notFilled = 'notFilled',
    match = 'match',
    notMatch = 'notMatch',
    Include = 'Include',
    notInclude = 'notInclude',
    contains = 'contains',
    notContains = 'notContains',
    more = 'more',
    moreOrEqual = 'moreOrEqual',
    less = 'less',
    lessOrEqual = 'lessOrEqual',
    later = 'later',
    laterEqual = 'laterEqual',
    earlier = 'earlier',
    earlierEqual = 'earlierEqual',
    inInterval = 'inInterval',
    foundOne = 'foundOne',
    notFoundOne = 'notFoundOne',
    fileSigned = 'fileSigned',
    nameFileInclude = 'nameFileInclude',
    durationEqual = 'durationEqual',
    durationMore = 'durationMore',
    durationLess = 'durationLess',
    beginsInInterval = 'beginsInInterval',
    endInInterval = 'endInInterval',
}

export enum ElistDateFormat {
    day = 1,
    month = 2,
    year = 3,
}

/** Список возможных режимов условий для полей реестра */
export enum EConditionMode {
    visible = '1',
    required = '2',
}
